<template>

    <trax-ui-card title="Deferred items" v-if="enabled">
        <div class="row">
            <div class="col-12">
                <p style="white-space:pre-wrap;">{{ goals }}</p>
            </div>
        </div>
    </trax-ui-card>
    
</template>

<script>
    export default {

        data: function() {
            return {
                state: data.state
            }
        },

        computed: {

            enabled() {
                return this.state && this.state.goals_enabled
            },

            goals() {
                return this.enabled
                    ? this.state.goals
                    : ''
            },
        }
    }
</script>
